import axios from 'axios'
import moment from 'moment'
import { ValidationProvider, extend } from 'vee-validate'
import {
  required,
  email,
  alpha_num,
  max,
  min_value,
  max_value,
  integer,
  confirmed
} from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en'
import PhoneNumber from 'awesome-phonenumber'

extend('required', {
  ...required,
  message: en.messages['required']
})
extend('email', {
  ...email,
  message: en.messages['email']
})
extend('alpha_num', {
  ...alpha_num,
  message: en.messages['alpha_num']
})
extend('max', {
  ...max,
  message: en.messages['max']
})
extend('min_value', {
  ...min_value,
  message: en.messages['min_value']
})
extend('max_value', {
  ...max_value,
  message: en.messages['max_value']
})
extend('integer', {
  ...integer,
  message: en.messages['integer']
})
extend('confirmed', {
  ...confirmed,
  message: en.messages['confirmed']
})

extend('decimal', {
  validate: (value) => {
    if (value === null || value === undefined || value === '') {
      return false
    }

    const separator = '.'
    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d+)?([eE]{1}[-]?\\d+)?$`)

    if (!regex.test(value)) {
      return false
    }

    const parsedValue = parseFloat(value)
    return parsedValue === parsedValue
  },
  message: field => `The ${field} field must be numeric and may contain decimal points.`
})

extend('date_format', {
  params: [ 'format' ],
  validate: (value, { format }) => {
    return moment(value, format, true).isValid()
  },
  message: (field, { format }) => `The date format of ${field} field is invalid. Use ${format}`
})

extend('phone_number', {
  params: ['phone'],
  validate: (value, { phone }) => {
    return new Promise(resolve => {
      let pn = new PhoneNumber(phone.number, phone.country_data.iso_3166_2)
      resolve({ valid: pn.isValid() })
    })
  },
  message: field => `${field} is not a valid phone number`,
})

extend('min-currency-value', {
  params: ['min'],
  validate(value, { min }) {
    if (Array.isArray(value) || value === null || value === undefined || value === '') {
      return false
    }
    return Number(value.replace(',', '')) >= min
  },
  message: (field, { min }) => `${field} min currency value is ${min}`,
})

extend('currency', {
  validate(value) {
    if (value === 0) {
      return true
    }
    if (value) {
      return (/(?=.)^\$?(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+)?(\.[0-9]{1,2})?$/.test(value))
    } else {
      return false
    }
  },
  message: 'Only currency format allowed',
})

extend('required-all', {
  computesRequired: true,
  validate: value => {
    if (value && value.constructor === Object) {
      return Object.entries(value).length > 0
    }
    return required.validate(value).valid
  },
  message: field => `The field ${field} is required`,
})

extend('email-available', {
  validate(value) {
    if (value) {
      return axios.post('/users/email-available', {
        email: value
      })
        .then(response => {
          return {
            valid: response.data.available
          }
        })
        .catch(() => {
          return false
        })
    } else {
      return false
    }
  },
  message: 'Email exists, please try with another email address',
})

export default ValidationProvider
